module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/title_bg_1-d774d311b548c9ee4594ef440db6c87b.svg";